import { CheckboxProps, FormControlLabel, FormControlLabelProps } from '@mui/material';

import { AppCheckbox } from 'components/core/AppCheckbox/AppCheckbox';
import React from 'react';

export interface AppCheckboxWithLabelProps {
  label: string;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';

  value?: any;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;

  formControlProps?: Omit<FormControlLabelProps, 'control' | 'label' | 'labelPlacement'>;
  checkboxProps?: Omit<CheckboxProps, 'value' | 'onChange' | 'checked'>;
}

export const AppCheckboxWithLabel = ({
  label,
  labelPlacement = 'top',
  value,
  checked,
  onChange,
  formControlProps,
  checkboxProps,
  /** rest is the props forwarded from Formik */
  ...rest
}: AppCheckboxWithLabelProps) => {
  const controlProps = {
    ...formControlProps,
    label,
    labelPlacement,
  };
  const checkProps = {
    ...checkboxProps,
    ...rest,
    value,
    onChange,
    checked,
  };

  return (
    <FormControlLabel
      {...controlProps}
      componentsProps={{
        typography: {
          variant: 'body2',
        },
      }}
      control={<AppCheckbox {...checkProps} />}
    />
  );
};
